import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  Heading,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  ContentDisplay
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import type { ProfitPreview } from '@/modules/trade/services/profit';

interface Props {
  terms: ProfitPreview['terms'];
  isOpen: boolean;
  isLoading: boolean;
}

interface EmitEvents {
  (event: 'accept'): void;
  (event: 'cancel'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAcceptTerms',
  props: {
    terms: null,
    isOpen: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["accept", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'accept'): void;
  (event: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  terms: ProfitPreview['terms'];
  isOpen: boolean;
  isLoading: boolean;
}




return { __sfc: true,props, emit, Modal, Heading, BaseText, ButtonContainer, ButtonPrimary, ButtonSecondary, ContentDisplay, NebraskaColors }
}

})